import { LanguageEnum } from '@distribusion/portal-lib/constants';
import i18n, {
  TFunction as TFunctionBase,
  useTranslation as useTranslationBase,
  UseTranslationOptions,
} from '@distribusion/portal-lib/i18n';

export const NAMESPACE = 'root';

export type TFunction = TFunctionBase<typeof NAMESPACE>;

const instance = i18n.getInstance();

instance.on('initialized', function () {
  instance.addResourceBundle(LanguageEnum.EN, NAMESPACE, require('locales/en/root.json'));
});

export const useTranslation = (options?: UseTranslationOptions) =>
  useTranslationBase(NAMESPACE, options);
